module.exports = __webpack_public_path__ + "img/head.38846775.png";